import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, Modal } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';
import { Broadcaster } from './broadcaster';
import { Localization } from './app.localization'
import { MyApp } from './app.component';
import { RecommendPage } from '../pages/recommend/recommend';
import { LocationPage } from '../pages/location/location';
import { RankingPage } from '../pages/ranking/ranking';
import { MenulayoutsPage } from '../pages/menulayouts/menulayouts';
import { FavoritesPage } from '../pages/favorites/favorites';
import { MyPagePage } from '../pages/mypage/mypage';
import { ListPage } from '../pages/list/list';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPage } from '../pages/login/login';
import { PurchasePage } from '../pages/purchase/purchase';
import { ErrorPage } from '../pages/error/error';
import { OrderStopPage } from '../pages/order-stop/order-stop';
import { LoadingPage } from '../pages/loading/loading';
import { MenulistPage } from '../pages/menulist/menulist';
import { CommercePage } from '../pages/commerce/commerce';
import { ResendMailPage } from '../pages/resend-mail/resend-mail';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { OrderHistoryPage } from '../pages/order-history/order-history';
import { SendOrderPage } from '../pages/send-order/send-order';
import { GridPage } from '../pages/grid/grid';
import { MobileOrderComponent } from '../components/mobile-order/mobile-order';
import { GmoPaymentComponent } from '../components/gmo-payment/gmo-payment';
import { Router, RouteInfo } from '../components/Router';
import { MobileOrderPaymentComponent } from '../components/mobile-order-payment/mobile-order-payment';
import { PaygentPaymentComponent } from '../components/paygent-payment/paygent-payment';
import { OkagepayPaymentComponent } from '../components/okagepay-payment/okagepay-payment';
import { CustomModalComponent } from '../components/custom-modal/custom-modal';
import { OrderModalPage } from '../pages/order-modal/order-modal';
import { OkageGoGoogleAnalyticsProvider } from '../providers/okage-go-google-analytics/okage-go-google-analytics';
import { HeaderCartComponent } from '../components/header-cart/header-cart';
import { MenuComponent } from '../pages/menulist/menu/menu';
import { OrderComponent } from '../components/order/order';
import { StyleLoaderProvider } from '../providers/style-loader/style-loader';
import { SelectReceiveModalComponent } from '../components/select-receive-modal/select-receive-modal';
import { ConfirmOrderModalComponent } from '../components/confirm-order-modal/confirm-order-modal';
import { OkageStorageProvider } from '../providers/okage-storage/okage-storage';
import { SubmenuSelectionComponent } from '../components/submenu-selection/submenu-selection';
import { SubmenuSelectionBoxComponent } from '../components/submenu-selection-box/submenu-selection-box';

@NgModule({
  declarations: [
    MyApp,
    RecommendPage,
    LocationPage,
    FavoritesPage,
    RankingPage,
    MenulayoutsPage,
    MyPagePage,
    ListPage,
    TabsPage,
    OrderHistoryPage,
    OrderStopPage,
    SendOrderPage,
    GridPage,
    LoadingPage,
    ErrorPage,
    PurchasePage,
    LoginPage,
    MenulistPage,
    CommercePage,
    ResendMailPage,
    MobileOrderComponent,
    GmoPaymentComponent,
    MobileOrderPaymentComponent,
    PaygentPaymentComponent,
    OkagepayPaymentComponent,
    CustomModalComponent,
    OrderModalPage,
    HeaderCartComponent,
    MenuComponent,
    OrderComponent,
    SelectReceiveModalComponent,
    ConfirmOrderModalComponent,
    SubmenuSelectionComponent,
    SubmenuSelectionBoxComponent,
  ],
  imports: [
    HttpModule,
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot({
      name: '_ionicstorage',
      driverOrder: ['indexeddb', 'localstorage']
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    RecommendPage,
    LocationPage,
    RankingPage,
    MenulayoutsPage,
    FavoritesPage,
    MyPagePage,
    ListPage,
    TabsPage,
    OrderHistoryPage,
    SendOrderPage,
    OrderStopPage,
    GridPage,
    ErrorPage,
    PurchasePage,
    LoadingPage,
    LoginPage,
    MenulistPage,
    CommercePage,
    ResendMailPage,
    CustomModalComponent,
    OrderModalPage,
    HeaderCartComponent,
    SelectReceiveModalComponent,
    ConfirmOrderModalComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Broadcaster,
    Localization,
    Router,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    OkageGoGoogleAnalyticsProvider,
    StyleLoaderProvider,
    OkageStorageProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts